<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
    <div v-else>
      <component-header
        title="Advertisements"
        @search-query="(val) => (filter = val)"
        :isLoading="loading"
        @reload-data="getAdvertisementList"
        :hasback="true"
        @back-press="backBtn"
        @create-press="$router.push({ path: '/advertisement/create' })"
      />
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            class="tableRadius"
            responsive
            :fields="adsColumns"
            :items="ads"
            :dark="dark"
            :filter="filter"
            :hover="hover"
            thead-class="header"
            :striped="striped"
            :bordered="bordered"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            show-empty
            @filtered="onFilter"
            :fixed="fixed"
            ref="ads"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="active" slot-scope="data">
              <div class="table-row">
                <c-switch
                  class="mx-1"
                  color="primary"
                  v-model="data.item.active"
                  label
                  variant="pill"
                  data-on="yes"
                  data-off="yes"
                />
              </div>
            </template>
            <template slot="visibility" slot-scope="data">
              <div class="table-row">
                {{
                  data &&
                  data.item &&
                  data.item.target &&
                  data.item.target.visibility &&
                  data.item.target.visibility[0]
                    ? data &&
                      data.item &&
                      data.item.target &&
                      data.item.target.visibility &&
                      data.item.target.visibility[0]
                    : (data &&
                        data.item &&
                        data.item.target &&
                        data.item.target.visibility &&
                        data.item.target.visibility.type) ||
                      "-"
                }}
              </div>
            </template>
            <template slot="icon" slot-scope="data">
              <div class="table-row">
                <img
                  style="height: 80px; width: 80px; text-align: center"
                  :src="data.item.icon"
                />
              </div>
            </template>
            <template slot="action" slot-scope="data">
              <div class="inline_btnTable">
                <b-button
                  size="sm"
                  class="button-circle mr-2 view"
                  @click="viewAd(data.item)"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="button-circle mr-2 pencil"
                  @click="editAd(data.item)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="button-circle delete"
                  @click="deleteAd(data.item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
        <div style="float: right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { Switch as cSwitch } from "@coreui/vue";
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "Advertisement",
  components: {
    ebButton,
    cSwitch,
    ComponentHeader,
    AtomSpinner,
  },
  data() {
    return {
      filterCount: 0,
      partner: {},
      loading: false,
      currentPage: 1,
      filter: "",
      perPage: 5,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "createdAt",
      sortDesc: true,
      adsColumns: [
        {
          key: "icon",
        },
        {
          key: "type",
        },
        {
          key: "placement",
        },
        {
          key: "visibility",
        },
        {
          key: "active",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      AdList: "advertisement/GetAdList",
      userId: "auth/getUserID",
      partnerAllData: "partner/GetPartnerData",
    }),
    ads() {
      const addata = this.AdList;
      let data = [];
      if (Array.isArray(addata) && addata.length > 0) {
        data = addata.map((obj) => ({
          ...obj,
          locationRadius: obj.target.locationRadius,
          icon: obj?.icon?.fileUrl || "",
        }));
        return data;
      } else if (Array.isArray(addata) && addata.length === 0) {
        return [];
      } else {
        let dataArr = [addata];
        dataArr = dataArr.map((obj) => ({
          ...obj,
          locationRadius: obj.target.locationRadius,
          icon: obj?.icon?.fileUrl || "",
        }));
        return dataArr;
      }
    },
  },
  methods: {
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    viewAd(data) {
      this.$router.push({
        name: "view-advertisement",
        params: { id: data._id },
      });
    },
    editAd(data) {
      this.$router.push({
        name: "edit-advertisement",
        params: { id: data._id },
      });
    },
    deleteAd(data) {
      this.$swal({
        title: "Delete this Ad?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("advertisement/deleteAd", data._id)
            .then(() => {
              this.$toasted.success("Advertisement Deleted Successfully!");
              // Fetch the updated ad list
              let payload = {
                all: true, // Ensure all ads are fetched
              };
              if (
                this.$currentUserData.category === "SELLER" &&
                this.$currentUserData._id
              ) {
                payload.provider = this.$currentUserData._id;
              }
              this.$store.dispatch(
                "advertisement/fetchAdListforTenant",
                payload
              );
            })
            .catch((err) => {
              this.$toasted.error("Ad not deleted");
            });
        }
      });
    },
    getAdvertisementList() {
      this.loading = true;
      let payload =
        this.$currentUserData.category === "SELLER"
          ? {
              provider: this.$currentUserData._id,
              all: true,
            }
          : {
              all: true,
            };
      if (this.$route.params.id) {
        payload.provider = this.$route.params.id;
      }
      this.$store
        .dispatch("advertisement/fetchAdListforTenant", payload)
        .then((data) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    backBtn() {
      if (this.$route.params.id) {
        this.$router.push("./basic-info");
      } else {
        this.$router.push("/dashboard");
      }
    },
  },
  async mounted() {
    this.getAdvertisementList();
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
.form-div label {
  margin-top: 8px;
}
</style>
